import script from "./UChat.vue?vue&type=script&setup=true&lang=js"
export * from "./UChat.vue?vue&type=script&setup=true&lang=js"

import "./UChat.vue?vue&type=style&index=0&id=3baff80e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3baff80e"]])

export default __exports__